<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row" v-if="hasItems">
              <div class="col-lg-12 col-xl-12">
                <div class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  ">
                  <div class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    ">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Chart
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-xl-12">
                <div id="chart">
                  <apexchart ref="radar" type="pie" width="600" :options="chartOptions" :series="chartOptions.series">
                  </apexchart>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  ">
                  <div class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    ">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Order
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div id="sale_wrapper" class="dataTables_wrapper no-footer">
                          <div class="dataTables_length" id="sale_length">
                            <label>Show
                              <select name="sale_length" class="" v-model="limit" v-on:change="fetchorders()">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                              entries</label>

                          </div>
                          <div class="dataTables_filter ml-3 mr-3">
                            <label>Delivery time
                              <select name="delivery_time" class="" v-model="delivery_time" v-on:change="fetchorders()">
                                <option value="" selected>Бүгд</option>
                                <option v-for="delivery_time in delivery_times" v:key="delivery_time.id"
                                  :value="delivery_time.id">{{ delivery_time.name }}</option>
                              </select></label>

                          </div>
                          <div class="dataTables_filter ml-3 mr-3">
                            <label>Order status
                              <select name="order_status" class="" v-model="order_status" v-on:change="fetchorders()">
                                <option value="" selected>Бүгд</option>
                                <option value="Pending">Pending</option>
                                <option value="Complete">Complete</option>
                              </select></label>

                          </div>
                          <div class="dataTables_filter ml-3 mr-3">
                            <label>Shipping status
                              <select name="shipping_status_filter" class="" v-model="shipping_status_filter"
                                v-on:change="fetchorders()">
                                <option value="" selected>Бүгд</option>
                                <option value="Pending">Pending</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Complete">Complete</option>
                              </select></label>

                          </div>
                          <div class="dataTables_filter ml-3 mr-3">
                            <label>Date from
                              <input type="date" v-model="datefrom" v-on:change="fetchorders()">

                            </label>
                            <label>Date to
                              <input type="date" v-model="dateto" v-on:change="fetchorders()">

                            </label>
                            <button v-if="this.datefrom != '' && this.dateto != ''" @click="clearDate">clear</button>
                          </div>
                          <div id="sale_filter" class="dataTables_filter">
                            <label>Search:<input type="test" class="" placeholder="" v-model="searchParameter"
                                @keyup="fetchorders()" /></label>
                            <button v-if="this.searchParameter != ''" @click="clearSearch">clear</button>

                          </div>
                          <table id="sale" class="display dataTable no-footer" sale="grid">
                            <thead class="text-body">
                              <tr sale="row">
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Order id
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Order Status
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Shipping Status
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Phone
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Order Price {{ getCurrencyTitle() }}
                                </th>

                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Order Date
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Payment Method
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                  aria-label="sale: activate to sort column ascending" style="width: 95.5288px">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <tr class="kt-table-row kt-table-row-level-0 odd" sale="row" v-for="order in orders"
                                v-bind:key="order.id">
                                <td>
                                  {{ order.order_id }}
                                </td>
                                <td>
                                  {{ order.order_status }}
                                </td>
                                <td>
                                  {{ order.shipping_status }}
                                </td>
                                <td>
                                  {{ order.billing_phone }}
                                </td>
                                <td>
                                  {{ order.order_price }}
                                </td>
                                <td>
                                  {{ order.order_date }}
                                </td>
                                <td>
                                  {{ order.payment_method }}
                                </td>
                                <td>
                                  <a :href="'/admin/order/' + order.order_id" class="click-edit" id="click-edit1"
                                    data-toggle="tooltip" title="" data-placement="right"
                                    data-original-title="Check out more demos"><i class="fa fa-edit"></i></a>
                                  <button @click="fetchOrderDetails(order)" class="btn " data-toggle="modal"
                                    data-target="#exampleModal" id="click-eye1" title="" data-placement="right"
                                    data-original-title="View"><i class="fa fa-eye"></i></button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ul class="pagination pagination-sm m-0 float-right">
                            <li v-bind:class="[
                              { disabled: !pagination.prev_page_url },
                            ]">
                              <a class="page-link" href="#" @click="fetchorders(pagination.prev_page_url)">Previous</a>
                            </li>

                            <li class="disabled">
                              <a class="page-link text-dark" href="#">Page {{ pagination.current_page }} of
                                {{ pagination.last_page }}</a>
                            </li>

                            <li v-bind:class="[
                              { disabled: !pagination.next_page_url },
                            ]" class="page-item">
                              <a class="page-link" href="#" @click="fetchorders(pagination.next_page_url)">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Order</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <div class="card">
                  <div class="card-header">
                    Shipping address
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">First Name: {{ delivery_first_name }}</li>
                    <li class="list-group-item">Last Name: {{ delivery_last_name }}</li>
                    <li class="list-group-item">Address: {{ delivery_street_aadress }}</li>
                    <li class="list-group-item">City: {{ delivery_city }}</li>
                    <li class="list-group-item">Country: {{ country_name }}</li>
                    <li class="list-group-item">State: {{ state_name }}</li>
                    <li class="list-group-item">Zip Code: {{ delivery_postcode }}</li>
                    <li class="list-group-item">Phone: {{ delivery_phone }}</li>
                  </ul>
                </div>
              </div>
              <div class="col-9">
                <div class="card">
                  <div class="card-header">
                    Order products
                  </div>
                  <table class="table table-striped text-body">
                    <thead>
                      <tr class="d-flex">
                        <th class="col-2"></th>
                        <th class="col-3">ITEM"S</th>
                        <th class="col-2">Price</th>
                        <th class="col-2">Discount PRICE</th>
                        <th class="col-1">QTY</th>
                        <th class="col-2">SUBTOTAL</th>
                      </tr>
                    </thead>
                    <tbody id="order-show-detail">
                      <tr class="d-flex responsive-lay" v-for="detail in order_detail"
                        v-if="detail.product.product_type == 'variable'">
                        <td class="col-12 col-md-2">
                          <img class="img-fluid order-image"
                          :src="'/gallary/' +detail.product_combination.gallary.gallary_name" 
                            :alt="'/gallary/' +  detail.product_combination.gallary.gallary_name" 
                            style="width: 50px; height: 60px" />
                        </td>
                        <td class="col-12 col-md-3 item-detail-left">
                          <div class="text-body">
                            <h6 class="order-product-name">
                              {{ detail.product.detail[0].title }}
                              <span v-for="variation in detail
                                .product_combination.combination">
                                {{ variation.variation.detail[0].name }}
                              </span>
                            </h6>
                          </div>
                        </td>
                        <td class="tag-color col-12 col-md-2 order-price">
                          {{ detail.product_price }}
                        </td>
                        <td class="tag-color col-12 col-md-2 order-price">
                          {{ (detail.product_discount > 0) ? detail.product_discount : "-" }}
                        </td>
                        <td class="col-12 col-md-1">
                          <div class="input-group">
                            {{ detail.product_qty }}
                          </div>
                        </td>
                        <td class="tag-s col-12 col-md-2 order-sub-price">
                          {{ parseFloat(detail.product_total).toFixed(2) }}
                        </td>
                      </tr>

                      <tr class="d-flex responsive-lay" v-for="detail in order_detail"
                        v-if="detail.product.product_type == 'simple'">
                        <td class="col-12 col-md-2">
                          <img class="img-fluid order-image" :src="'/gallary/' +
                            detail.product.product_gallary
                              .gallary_name
                            " :alt="'/gallary/' +
    detail.product.product_gallary
      .gallary_name
    " style="width: 50px; height: 60px" />
                        </td>
                        <td class="col-12 col-md-3 item-detail-left">
                          <div class="text-body">
                            <h6 class="order-product-name">
                              {{ detail.product.detail[0].title }}
                            </h6>
                          </div>
                        </td>
                        <td class="tag-color col-12 col-md-2 order-price">
                          {{ detail.product_price }}
                        </td>
                        <td class="tag-color col-12 col-md-2 order-price">
                          {{ (detail.product_discount > 0) ? detail.product_discount : "-" }}
                        </td>
                        <td class="col-12 col-md-1">
                          <div class="input-group">
                            {{ detail.product_qty }}
                          </div>
                        </td>
                        <td class="tag-s col-12 col-md-2 order-sub-price">
                          {{ parseFloat(detail.product_total).toFixed(2) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card">
                  <div class="card-header">
                    Order details
                  </div>
                  <div class="card-body">
                    <p class="card-text">Delivery time: {{ delivery_time }}</p>
                    <p class="card-text">Delivery date: {{ delivery_date }}</p>
                    <p class="card-text">Order notes: {{ order_notes }}</p>
                    <p class="card-text">Order status: {{ order_status }}</p>
                    <p class="card-text">Shipping status:
                      <select name="order_status" class="" v-model="shipping_status" v-on:change="shippingstatus()">
                        <option value="Pending">Pending</option>
                        <option value="Shipped">Shipped</option>
                        <option value="Complete">Complete</option>
                      </select>
                    </p>
                    <p class="card-text">Payment method: {{ payment_method }}</p>
                    <p class="card-text">Order date: {{ order_date }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''">
      <div class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        ">
        <h4 class="font-size-h4 font-weight-bold m-0">Add sale</h4>
        <a href="#" class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          " v-on:click="display_form = 0">
          <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
            </path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Name </label>
              <input type="text" name="text" v-model="order.name" class="form-control" />
              <small class="form-text text-danger" v-if="errors.has('name')" v-text="errors.get('name')"></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Direction </label>
              <select v-model="order.direction">
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
              <small class="form-text text-danger" v-if="errors.has('direction')"
                v-text="errors.get('direction')"></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Code </label>
              <input type="text" name="text" v-model="order.code" class="form-control" />
              <small class="form-text text-danger" v-if="errors.has('code')" v-text="errors.get('code')"></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Directory </label>
              <input type="text" name="text" v-model="order.directory" class="form-control" />
              <small class="form-text text-danger" v-if="errors.has('directory')"
                v-text="errors.get('directory')"></small>
            </div>
            <div class="form-group">
              <input type="checkbox" name="text" v-model="order.is_default" id="is_default" class="form-check-input" />
              <label class="text-dark" for="is_default">Set as default </label>
              <small class="form-text text-danger" v-if="errors.has('is_default')"
                v-text="errors.get('is_default')"></small>
            </div>
          </div>
        </div>
        <button type="button" @click="addUpdatesale()" class="btn btn-primary">
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {

      chartOptions: {
        series: [],
        chart: {
          width: 600,
          height: 'auto',
          type: 'pie',
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      order_id: '',
      display_form: 0,
      orders: [],
      searchParameter: "",
      sortBy: "id",
      sortType: "DESC",
      limit: 10,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {},
      request_method: "",
      is_default: "0",
      token: [],
      currency: [],
      datefrom: "",
      dateto: "",
      delivery_time: "",
      errors: new ErrorHandling(),
      order_products: [],
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      labels: [],
      delivery_first_name: "",
      delivery_last_name: "",
      delivery_city: "",
      delivery_country: "",
      state_name: "",
      delivery_zip: "",
      delivery_street_aadress: "",
      delivery_name: "",
      delivery_phone: "",
      delivery_postcode: "",
      country_name: "",
      order_notes: "",
      delivery_time: "",
      delivery_date: "",
      order_status: "",
      payment_method: "",
      order_date: "",
      order_detail: [],
      order_status: "",
      delivery_times: "",
      shipping_status: "",
      shipping_status_filter: "",
      order_id: ""
    };
  },
  created() {
    this.getDeliveryTime();
  },
  methods: {
    shippingstatus() {
      var token = localStorage.getItem("token");
      token = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var data = {
        shipping_status: this.shipping_status
      };
      axios
        .patch('/api/admin/order/' + this.order_id, data, token)
        .then((res) => {
          this.delivery_times = res.data.data;
        })
        .finally(() => (this.$parent.loading = false));

    },
    fetchOrderDetails(order) {

      this.order_id = order.order_id
      this.order_detail = order.order_detail
      this.delivery_first_name = order.delivery_first_name
      this.delivery_last_name = order.delivery_last_name
      this.delivery_city = order.delivery_city
      this.delivery_country = order.delivery_country
      this.state_name = order.state_name
      this.delivery_zip = order.delivery_zip
      this.delivery_street_aadress = order.delivery_street_aadress
      this.delivery_name = order.delivery_name
      this.delivery_phone = order.delivery_phone
      this.delivery_postcode = order.delivery_postcode
      this.country_name = order.country_name
      this.order_notes = order.order_notes
      if (order.delivery_time == 1) {
        this.delivery_time = "Early bird"
      } else if (order.delivery_time == 2) {
        this.delivery_time = "Busy day"
      } else if (order.delivery_time == 3) {
        this.delivery_time = "Late night"
      }
      this.delivery_date = order.delivery_day
      this.order_status = order.order_status
      this.payment_method = order.payment_method
      this.order_date = order.order_date
      this.shipping_status = order.shipping_status
    },
    clearDate() {
      this.datefrom = "";
      this.dateto = "";
      this.fetchorders();
    },
    fetchCurrency() {
      this.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.currency = res.data.data;
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    fetchorders(page_url) {
      this.$parent.loading = true;
      let vm = this;
      page_url = page_url || "/api/admin/order";
      var arr = page_url.split("?");

      if (arr.length > 1) {
        page_url += "&limit=" + this.limit;
      } else {
        page_url += "?limit=" + this.limit;
      }
      if (this.searchParameter != null) {
        page_url += "&searchParameter=" + this.searchParameter;
      }
      if (this.datefrom != null) {
        page_url += "&date_from=" + this.datefrom;
      }
      if (this.dateto != null) {
        page_url += "&date_to=" + this.dateto;
      }
      if (this.shipping_status_filter != null) {
        page_url += "&shipping_status_filter=" + this.shipping_status_filter;
      }
      if (this.delivery_time != null) {
        page_url += "&delivery_time=" + this.delivery_time;
      }
      if (this.order_status != null) {
        page_url += "&order_status=" + this.order_status;
      }
      page_url += "&sortBy=" + this.sortBy + "&sortType=" + this.sortType;

      var responseData = {};

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.orders = res.data.data;
          vm.makePagination(res.data.meta, res.data.links);
          this.order_products = [];
          this.labels = [];
          for (var i = 0; i < this.orders.length; i++) {
            this.order_products.push(this.orders[i].order_detail);
          }
          this.getPieChartData();
        })
        .finally(() => (this.$parent.loading = false));

    },
    getDeliveryTime() {
      var token = localStorage.getItem("token");
      token = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get('/api/admin/delivery_times', token)
        .then((res) => {
          this.delivery_times = res.data.data;
        })
        .finally(() => (this.$parent.loading = false));

    },
    getPieChartData() {
      for (var i = 0; i < this.order_products.length; i++) {
        for (var j = 0; j < this.order_products[i].length; j++) {
          let qty = this.order_products[i][j].product_qty;
          if (this.order_products[i][j].product_qty === null) {
            qty = 0;
          }
          const input = {
            name: this.order_products[i][j].product.seo_meta_tag,
            unit: this.order_products[i][j].product.seo_desc,
            qty: parseInt(qty),
          };
          this.labels.push(input);
        }
      }
      const output = this.labels.reduce((acc, cur) => {
        const index = acc.findIndex(item => item.name === cur.name);
        if (index === -1) {
          acc.push(cur);
        } else {
          acc[index].qty = (Number(acc[index].qty) || 0) + (Number(cur.qty) || 0);
        }
        return acc;
      }, []);
      this.labels = output;
      this.chartOptions.series = [];
      this.chartOptions.labels = [];
      for (var i = 0; i < this.labels.length; i++) {

        this.chartOptions.series.push(this.labels[i].qty);
        this.chartOptions.labels.push(this.labels[i].name + ' ' + this.labels[i].qty);
        // + this.labels[i].unit
      }
      this.$refs.radar.updateOptions(this.chartOptions);
    },
    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },

    makePagination(meta, links) {
      let pagination = {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };

      this.pagination = pagination;
    },
    deleteOrders(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/order/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.fetchorders();
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.$parent.loading = false));
      }
    },
    clearSearch() {
      this.searchParameter = "",
        this.fetchorders();
    }
  },
  computed: {
    hasItems() {
      return Array.isArray(this.labels) && this.labels.length > 0
    }
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCurrency();
    this.fetchorders();
  },
  props: ["loading"],
};
</script>
